import { createLazyComponent, LazyModule } from 'owa-bundling';
import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';

const hubListHeaderModule = new LazyModule(
    () => import(/* webpackChunkName: "HubListHeader" */ './hubListHeader')
);

export interface HubListHeaderProps {
    readonly areAllItemsChecked: boolean;
    readonly filterButtonAriaLabel: string;
    readonly title: string;
    readonly hideCheckAll: boolean;
    readonly hideOptionsDropDown: boolean;
    readonly noFilterSelected: boolean;
    readonly currentOptionsText: string;
    readonly optionsDropDownItems: IContextualMenuItem[];
    readonly onCheckAllItems: () => void;
    readonly onClearAllItems: () => void;
    readonly onRemoveFilter: () => void;
}

export default createLazyComponent(hubListHeaderModule, m => m.default);
